import { Title } from '@/pages/menu-managements/services/title';

export type SearchItem = {
  id: string;
  title: Title;
  memo: string | null;
};

export type SortObject = {
  id: string;
  sort_index: number;
};

export type SearchItemParams = {
  associate_brand_id: string;
  title: string;
};

export const getSearchItems = (searchItems: SearchItem[]): SortObject[] => {
  return searchItems.map((item, index) => {
    return {
      id: item.id,
      sort_index: index + 1,
    };
  });
};
